<!--<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-clip-rotate-multiple"></ngx-spinner>-->
<ngx-spinner
    [hidden]="atlasSharedService.sharingCurrentViewStatus.btnClicked || atlasSharedService.sharedViewItems.isLoading"></ngx-spinner>

<ngx-spinner name="marker-data"></ngx-spinner>
<div [hidden]="!atlasSharedService.sharingCurrentViewStatus.btnClicked">
    <div class="overlay">
        <div class="overlay-content">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-md-offset-3 col-lg-offset-3 pt-4">
                        <div class="progress-bar" [style.width.%]="atlasSharedService.shareViewProgress.toSend">
                            <label *ngIf="atlasSharedService.shareViewProgress.toSend">
                                {{atlasSharedService.shareViewProgress.toSend}}%
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<router-outlet></router-outlet>